// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__-KU88","img":"Image_img__qQTZ7","skeleton":"Image_skeleton__XgQDd"};